module.exports = __webpack_public_path__ + "img/886-9a33a4.png";